import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * Dismissible banner that appears when the browser fires `beforeinstallprompt`.
 * Allows user to install the PWA to their home screen or desktop.
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("ap_install_dismissed_at")) {
      const last = Number(localStorage.getItem("ap_install_dismissed_at"));
      // Don't show again for 7 days after dismissal
      if (Date.now() - last < 7 * 24 * 60 * 60 * 1000) return;
    }
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    return () => window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
      setDeferred(null);
    }
  };

  const dismiss = () => {
    localStorage.setItem("ap_install_dismissed_at", String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="install-prompt" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-50 bg-slate-900 text-white shadow-2xl border-l-4 border-orange-500">
      <div className="p-4 flex items-start gap-3">
        <Download className="w-5 h-5 text-orange-400 flex-shrink-0 mt-1" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-extrabold text-sm">Instala AutoPresupuestos</div>
          <p className="text-xs text-white/70 mt-1">Ábrela como app, sin navegador, y escanea tickets en la obra.</p>
          <div className="flex gap-2 mt-3">
            <button onClick={install} data-testid="install-prompt-btn" className="h-9 px-4 btn-brand text-xs font-bold inline-flex items-center gap-2">Instalar</button>
            <button onClick={dismiss} data-testid="install-prompt-dismiss" className="h-9 px-3 text-xs font-semibold text-white/70 hover:text-white">Ahora no</button>
          </div>
        </div>
        <button onClick={dismiss} className="p-1 text-white/50 hover:text-white -mr-1 -mt-1"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
